// القاعدة الذهبية للوقت:
// - السجلات الزمنية للعمليات (حضور، إقرار راتب) تُعرَض بتوقيت مكان تنفيذها المخزّن → localDateTimeAt.
// - العرض العام غير المرتبط بعملية يستخدم توقيت الجهاز → localDateTime. (توقيت الفرع مرفوض نهائياً.)
const _p = (n) => String(n).padStart(2, "0");

const _parse = (iso) => {
  const hasTz = /[zZ]$|[+-]\d\d:?\d\d$/.test(iso);
  return new Date(hasTz ? iso : `${iso}Z`);
};

export const localDateTime = (iso) => {
  if (!iso) return "";
  const d = _parse(iso);
  if (Number.isNaN(d.getTime())) return String(iso).slice(0, 16).replace("T", " ");
  return `${d.getFullYear()}-${_p(d.getMonth() + 1)}-${_p(d.getDate())} ${_p(d.getHours())}:${_p(d.getMinutes())}`;
};

// يعرض الوقت بإزاحة دقائق محددة (توقيت مكان العملية المخزّن) — ثابت لا يعتمد على جهاز المُشاهد.
export const localDateTimeAt = (iso, offsetMinutes) => {
  if (!iso) return "";
  if (!Number.isFinite(offsetMinutes)) return localDateTime(iso);
  const d = _parse(iso);
  if (Number.isNaN(d.getTime())) return String(iso).slice(0, 16).replace("T", " ");
  const b = new Date(d.getTime() + offsetMinutes * 60000);
  return `${b.getUTCFullYear()}-${_p(b.getUTCMonth() + 1)}-${_p(b.getUTCDate())} ${_p(b.getUTCHours())}:${_p(b.getUTCMinutes())}`;
};
